import { Draft } from './models';

export async function migrateDraft(oldDraft: any): Promise<Draft> {
  // Handle legacy format
  if (!oldDraft.raw && oldDraft.content) {
    // For now, just use the existing plainText or content
    return {
      id: oldDraft.id,
      raw: oldDraft.content,
      plainText: oldDraft.plainText || oldDraft.content,
      updated: oldDraft.lastModified || oldDraft.updated,
      platforms: oldDraft.platforms || {
        twitter: true,
        bluesky: true,
        farcaster: true
      }
    };
  }
  
  // Already in new format
  return oldDraft as Draft;
}

export async function migrateAllDrafts(oldDrafts: any[]): Promise<Draft[]> {
  return Promise.all(oldDrafts.map(migrateDraft));
} 
